module.exports = __webpack_public_path__ + "img/life.a8287753.jpg";